query getTopics {
  topics: getTopics {
    id
    name
    description
    status
    isSystemGenerated
    isUserEditable
    visibility {
      contentCreator
      topics
      acquisitionBooster
      materialUploads
    }
    landingpage {
      id
      slug
    }
  }
}
